var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#010101;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.9,
    y: 0.8,
    fill: "currentColor",
    width: 19.8,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 0.8,
    fill: "currentColor",
    width: 19.8,
    height: 46.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 2.7,
    className: "st1",
    width: 16.5,
    height: 20.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 2.7,
    className: "st1",
    width: 16.5,
    height: 20.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 25.7,
    className: "st1",
    width: 6.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 25.7,
    className: "st1",
    width: 6.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3.9,25.7 9.6,25.7 15.8,31.9 23.7,31.9 23.7,34.2 14.9,34.2 8.5,27.8 3.9,27.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3.9,32.6 9.7,32.6 15.9,38.8 23.7,38.8 23.7,41 14.9,41 8.5,34.6 3.9,34.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "44.5,32.6 38.8,32.6 32.6,38.8 24.7,38.8 24.7,41 33.5,41 39.9,34.6 44.5,34.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "44.5,25.7 38.8,25.7 32.6,31.9 24.7,31.9 24.7,34.2 33.5,34.2 39.9,27.8 44.5,27.8  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.be741ca16df4d2d8cc61dc263fbe88f5.svg";
export { ForwardRef as ReactComponent };